import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  ApiConfiguration,
} from '../../api/api-configuration';

export function withBackendApiConfiguration(
  configurationParameters: { rootUrl?: string } = {}
): ApiConfiguration {
  const configuration = new ApiConfiguration();
  configuration.rootUrl = configurationParameters.rootUrl || '';
  return configuration;
}

export function provideApi(
  withConfiguration: ApiConfiguration = withBackendApiConfiguration()
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ApiConfiguration, useValue: withConfiguration },
  ]);
}
